import { render } from "./Bar.vue?vue&type=template&id=51e1b158&scoped=true&ts=true"
import script from "./Bar.vue?vue&type=script&lang=ts"
export * from "./Bar.vue?vue&type=script&lang=ts"

import "./Bar.vue?vue&type=style&index=0&id=51e1b158&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51e1b158"]])

export default __exports__